import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import './Home.css';

const BattlePage = () => {
    const navigate = useNavigate();
    const [backgroundImage, setBackgroundImage] = useState('');

    // All available trainer and villain images
    const allImages = [
        'albert-einstein.jpg', 'alexander-the-great.jpg', 'amelia-earhart.jpg', 'American-Horse.jpg',
        'attila-the-hun.jpg', 'Black-Hawk.jpg', 'Black-Kettle.jpg', 'blackbeard.jpg', 'Blue-Jacket.jpg',
        'boudica.jpg', 'captainamerica.jpg', 'che-guevara.jpg', 'Chief-Joseph.jpg', 'christopher-columbus.jpg',
        'cleopatra-vii.jpg', 'Cochise.jpg', 'Cornstalk.jpg', 'Crazy-Horse.jpg', 'date-masamune.jpg',
        'deadpool.jpg', 'Dull-Knife.jpg', 'edgar-allan-poe.jpg', 'emperor-meiji.jpg', 'ernest-shackleton.jpg',
        'fuma-kotaro.jpg', 'galileo-galilei.jpg', 'Gall.jpg', 'geisha-master.jpg', 'Geronimo.jpg',
        'hannibal-barca.jpg', 'hattori-hanzo.jpg', 'heros.jpg', 'honda-tadakatsu.jpg', 'ikebana-master.jpg',
        'ironman.jpg', 'isaac-newton.jpg', 'jiraiya.jpg', 'julius-caesar.jpg', 'kabuki-actor.jpg',
        'Kamiakin.jpg', 'kendo-master.jpg', 'king-leonidas.jpg', 'King-Philip-Metacomet.jpg', 'kyudo-archer.jpg',
        'Leschi.jpg', 'lewis-clark.jpg', 'Little-Turtle.jpg', 'Looking-Glass.jpg', 'Lozen.jpg',
        'Mangas-Coloradas.jpg', 'marco-polo.jpg', 'michelangelo.jpg', 'minamoto-yoritomo.jpg', 'minamoto-yoshitsune.jpg',
        'miyamoto-musashi.jpg', 'Nana.jpg', 'napoleon-bonaparte.jpg', 'nikola-tesla.jpg', 'noh-master.jpg',
        'oda-nobunaga.jpg', 'onmyoji-mystic.jpg', 'oscar-wilde.jpg', 'Osceola.jpg', 'p-t-barnum.jpg',
        'pablo-picasso.jpg', 'Pontiac.jpg', 'prince-shotoku.jpg', 'Pushmataha.jpg', 'Quanah-Parker.jpg',
        'rasputin.jpg', 'Red-Cloud.jpg', 'Roman-Nose.jpg', 'saito-hajime.jpg', 'sarutobi-sasuke.jpg',
        'Sequoyah.jpg', 'Sir-Agravaine-the-Proud.jpg', 'Sir-Balin-le-Savage.jpg', 'Sir-Bedivere-the-Bold.jpg',
        'Sir-Bors-de-Ganis.jpg', 'Sir-Brandiles-the-Bold.jpg', 'Sir-Brunor-le-Noir-The-Black-Knight.jpg',
        'Sir-Cador-of-Cornwall.jpg', 'Sir-Constantine-of-Britain.jpg', 'Sir-Dinadan-the-Humorous.jpg',
        'Sir-Dodinas-le-Savage.jpg', 'Sir-Gaheris-of-Orkney.jpg', 'Sir-Galahad-the-Pure.jpg',
        'Sir-Gareth-of-Orkney.jpg', 'Sir-Garlon-the-Invisible-Knight.jpg', 'Sir-Gawain-of-Orkney.jpg',
        'Sir-Kay-the-Seneschal.jpg', 'Sir-Lamorak-de-Galis.jpg', 'Sir-Lancelot-du-Lac.jpg',
        'Sir-Lucan-the-Butler.jpg', 'Sir-Marrok-the-Werewolf-Knight.jpg', 'Sir-Palamedes-the-Saracen.jpg',
        'Sir-Pelleas-the-Gentle.jpg', 'Sir-Pelleas-the-Younger.jpg', 'Sir-Pellimore-the-Questing-Beast-Hunter.jpg',
        'Sir-Percival-the-Welsh.jpg', 'Sir-Safir-the-Saracen.jpg', 'Sir-Segwarides-the-Jealous.jpg',
        'Sir-Tor-the-Bastard.jpg', 'Sir-Tristan-of-Lyonesse.jpg', 'Sir-William-Marshal-1st-Earl-of-Pembroke.jpg',
        'Sitting-Bull.jpg', 'sohei-monk.jpg', 'spartacus.jpg', 'spiderman.jpg', 'sumo-champion.jpg',
        'takeda-shingen.jpg', 'tea-master.jpg', 'Tecumseh.jpg', 'Ten-Bears.jpg', 'tengu-master.jpg',
        'theodore-roosevelt.jpg', 'thor.jpg', 'tokugawa-ieyasu.jpg', 'uesugi-kenshin.jpg',
        'v1.jpg', 'v10.jpg', 'v11.jpg', 'v12.jpg', 'v13.jpg', 'v14.jpg', 'v15.jpg', 'v16.jpg',
        'v17.jpg', 'v18.jpg', 'v19.jpg', 'v2.jpg', 'v20.jpg', 'v21.jpg', 'v22.jpg', 'v23.jpg',
        'v24.jpg', 'v25.jpg', 'v26.jpg', 'v27.jpg', 'v28.jpg', 'v29.jpg', 'v3.jpg', 'v30.jpg',
        'v31.jpg', 'v32.jpg', 'v33.jpg', 'v34.jpg', 'v35.jpg', 'v36.jpg', 'v37.jpg', 'v38.jpg',
        'v39.jpg', 'v4.jpg', 'v40.jpg', 'v41.jpg', 'v42.jpg', 'v43.jpg', 'v44.jpg', 'v45.jpg',
        'v46.jpg', 'v47.jpg', 'v48.jpg', 'v49.jpg', 'v5.jpg', 'v50.jpg', 'v51.jpg', 'v52.jpg',
        'v53.jpg', 'v54.jpg', 'v55.jpg', 'v56.jpg', 'v57.jpg', 'v58.jpg', 'v59.jpg', 'v6.jpg',
        'v60.jpg', 'v61.jpg', 'v62.jpg', 'v63.jpg', 'v64.jpg', 'v65.jpg', 'v66.jpg', 'v67.jpg',
        'v68.jpg', 'v69.jpg', 'v7.jpg', 'v70.jpg', 'v71.jpg', 'v72.jpg', 'v73.jpg', 'v74.jpg',
        'v75.jpg', 'v76.jpg', 'v77.jpg', 'v78.jpg', 'v79.jpg', 'v8.jpg', 'v80.jpg', 'v81.jpg',
        'v82.jpg', 'v83.jpg', 'v84.jpg', 'v85.jpg', 'v86.jpg', 'v87.jpg', 'v88.jpg', 'v9.jpg',
        'Victorio.jpg', 'vincent-van-gogh.jpg', 'wild-bill-hickok.jpg', 'wolfgang-amadeus-mozart.jpg',
        'wolverine.jpg', 'yamabushi-alt.jpg', 'yamabushi.jpg', 'zen-monk.jpg'
    ];

    // Select random background image on component mount
    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * allImages.length);
        const selectedImage = allImages[randomIndex];
        setBackgroundImage(`/assets/images/${selectedImage}`);
    }, []);

    // Updated battle workout options - ADDED CARD GAME OPTIONS
    const battleOptions = [
        {
            id: 'battle-story-mode',
            title: 'Battle Story Mode',
            description: 'Epic adventure with fitness challenges!',
            code: '',
            image: '/assets/images/story-mode.jpg',
            route: '/battle-story-mode',
            color: '#9900FF', // Purple theme
            sound: 'gameIntroMode2'
        },
        {
            id: 'battle-mode',
            title: 'Battle Mode',
            description: 'Face villains in epic workout battles!',
            code: '',
            image: '/assets/images/battle-mode.jpg',
            route: '/battle-selection',
            color: '#FF0000', // Red theme
            sound: 'gameIntroMode2'
        },
        {
            id: 'custom-battle-setup',
            title: 'Custom Battle Setup',
            description: 'Choose your exercises and difficulty level!',
            code: '',
            image: '/assets/images/custom-battle.jpg',
            route: '/custom-battle-setup',
            color: '#00FF00', // Neon Green theme
            sound: 'next22'
        },
        // 🆕 NEW: Card Game Options
        {
            id: 'card-collection',
            title: 'Card Collection',
            description: 'Browse your 520 BUMFIT cards - Train, Build, Battle & Move!',
            code: '',
            image: '/assets/images/card-collection.jpg',
            route: '/card-gallery',
            color: '#FF6B35', // Orange theme (matches Move cards)
            sound: 'gameIntroMode2'
        },
        {
            id: 'card-battle',
            title: 'Card Battle Arena',
            description: 'Battle other cards using your collection!',
            code: '',
            image: '/assets/images/card-battle.jpg',
            route: '/card-battle',
            color: '#977f00', // Purple theme
            sound: 'attack'
        }
    ];

    // Handle workout type selection
    const handleWorkoutSelect = (workoutType) => {
        console.log('Battle option selected:', workoutType);

        // Play category-specific sound
        try {
            if (workoutType.sound) {
                soundManager.playSound(workoutType.sound, 0.7);
            } else {
                soundManager.playButtonSound();
            }
        } catch (error) {
            console.warn('Sound error:', error);
        }

        // Navigate to specific route
        navigate(workoutType.route);
    };

    // Handle back to home
    const handleBackToHome = () => {
        try {
            soundManager.playButtonSound();
        } catch (error) {
            console.warn('Sound error:', error);
        }
        navigate('/');
    };

    // Handle viewing saved workouts
    const handleViewSavedWorkouts = () => {
        try {
            soundManager.playButtonSound();
        } catch (error) {
            console.warn('Sound error:', error);
        }
        navigate('/saved-workouts');
    };

    // Handle viewing progress graphs
    const handleViewProgressGraphs = () => {
        try {
            soundManager.playButtonSound();
        } catch (error) {
            console.warn('Sound error:', error);
        }
        navigate('/progress-graphs');
    };

    const handleViewWorkoutMilestones = () => {
        try {
            soundManager.playButtonSound();
        } catch (error) {
            console.warn('Sound error:', error);
        }
        navigate('/workout-milestones');
    };

    const handleManualWorkout = () => {
        try {
            soundManager.playButtonSound();
        } catch (error) {
            console.warn('Sound error:', error);
        }
        navigate('/manual-workout');
    };

    return (
        <div
            className="home-container battle-page"
            style={{
                backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
        >
            <div className="battle-background-overlay"></div>
            <header className="home-header">
                <button className="back-button" onClick={handleBackToHome}>
                    ← Back to Home
                </button>
                <h1>⚔️ BATTLE</h1>
                <p>Competitive workout battles against villains and challenges</p>
            </header>

            <div className="workout-types-grid">
                {battleOptions.map((type) => (
                    <div
                        key={type.id}
                        className="workout-type-card-link"
                        onClick={() => handleWorkoutSelect(type)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div
                            className="workout-type-card"
                            data-workout-id={type.id}
                            style={{
                                '--theme-color': type.color,
                                '--text-color': type.textColor || '#ffffff'
                            }}
                        >
                            <div className="workout-type-image">
                                <div
                                    className="image-placeholder"
                                    style={{
                                        backgroundColor: type.color,
                                        backgroundImage: `url(${type.image})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        color: type.textColor || '#ffffff'
                                    }}
                                >
                                    <span>{type.title}</span>
                                </div>
                            </div>
                            <div className="workout-type-info">
                                <h2 style={{
                                    color: type.textColor ? type.textColor : type.color
                                }}>{type.title}</h2>
                                <p style={{
                                    color: type.textColor ? '#333333' : '#b0b0b0'
                                }}>{type.description}</p>
                                <div className="theme-indicator" style={{ backgroundColor: type.color }}></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <footer className="home-footer">
                <div className="header-buttons">
                    {/* Saved Workouts Button */}
                    <button
                        className="saved-workouts-button"
                        onClick={handleViewSavedWorkouts}
                    >
                        📊 View Saved Workouts
                    </button>

                    {/* Workout Milestones Button */}
                    <button
                        className="workout-milestones-button"
                        onClick={handleViewWorkoutMilestones}
                    >
                        🏆 Workout Milestones
                    </button>

                    {/* Progress Graphs Button */}
                    <button
                        className="progress-graphs-button"
                        onClick={handleViewProgressGraphs}
                    >
                        📈 View Progress Graphs
                    </button>

                    {/* Manual Workout Button */}
                    <button
                        className="manual-workout-button"
                        onClick={handleManualWorkout}
                    >
                        📝 Manual Workout
                    </button>
                </div>
            </footer>
        </div>
    );
};

export default BattlePage;